import React from 'react';
import { IProps } from './types';
import { SignupStep } from 'constants/enums/signupStep.enum';

const StepBar:React.FC<IProps> = (props) => {
  /**
   * @description 依當前註冊步驟回傳對應 class
   * @param step 註冊步驟
   */
  const getClassName = (step:SignupStep) => {
    if (step === props.activeStep) return 'step-bar__item step-bar__item--active step-bar__item--pos';

    return step < props.activeStep ? 'step-bar__item step-bar__item--active' : 'step-bar__item';
  };

  return (
    <div className="step-bar">
      <div className={getClassName(SignupStep.ConsentNotice)}>
        <div className="step-bar__item-title">
          <div className="step-bar__item-index">01</div>
          <div className="step-bar__item-dot" />
        </div>
        <div className="step-bar__item-desc">同意相關告知事項</div>
      </div>
      <div className={props.activeStep === SignupStep.FillInMember
        ? getClassName(SignupStep.FillInMember)
        : getClassName(SignupStep.PreviewMemberInfo)}
      >
        <div className="step-bar__item-title">
          <div className="step-bar__item-index">02</div>
          <div className="step-bar__item-dot" />
        </div>
        <div className="step-bar__item-desc">會員資料填寫</div>
      </div>
      <div className={getClassName(SignupStep.OTPVerification)}>
        <div className="step-bar__item-title">
          <div className="step-bar__item-index">03</div>
          <div className="step-bar__item-dot" />
        </div>
        <div className="step-bar__item-desc">會員資料確認 / 身份驗證</div>
      </div>
      <div className={getClassName(SignupStep.SignupComplete)}>
        <div className="step-bar__item-title">
          <div className="step-bar__item-index">04</div>
          <div className="step-bar__item-dot" />
        </div>
        <div className="step-bar__item-desc">會員註冊成功</div>
      </div>
    </div>
  );
};

export default StepBar;
